import FlowState from '../../../../models/store/modules/otbc/flow-state.model';
import { LocationSuggestion } from '../../../../graphql/schema';
import { TestDriveMode } from '../../../../models/utilities/testdrive-mode.enum';
import { Prospect } from '../../../../models/entities/prospect.model';

export const mutations = {
  model(state: FlowState, payload: any): void {
    state.model = payload;
  },
  modelSelected(state: FlowState, payload: boolean): void {
    state.modelSelected = payload;
  },
  bookingSearchFinished(state: FlowState, payload: boolean): void {
    state.bookingSearchFinished = payload;
  },
  didBookingSearch(state: FlowState, payload: boolean): void {
    state.didBookingSearch = payload;
  },
  initialLocation(state: FlowState, payload: LocationSuggestion): void {
    state.initialLocation = payload;
  },
  locationQueryFreeText(state: FlowState, payload: string): void {
    state.locationQueryFreeText = payload;
  },
  requestLocationQueryFreeText(state: FlowState, payload: string): void {
    state.requestLocationQueryFreeText = payload;
  },
  requestLocation(state: FlowState, payload: LocationSuggestion): void {
    state.requestLocation = payload;
  },
  locationRadius(state: FlowState, payload: string): void {
    state.locationRadius = payload;
  },
  locationSelected(state: FlowState, payload: boolean): void {
    state.locationSelected = payload;
  },
  onlineCode(state: FlowState, payload: string): void {
    state.onlineCode = payload;
  },
  dealer(state: FlowState, payload: string): void {
    state.dealer = payload;
  },
  dealers(state: FlowState, payload: string[]): void {
    state.dealers = payload;
  },
  dealerTextFilterSearch(state: FlowState, payload: string): void {
    state.dealerTextFilterSearch = payload;
  },
  fixedDealer(state: FlowState, payload: string): void {
    state.fixedDealer = payload;
  },
  referrer(state: FlowState, payload: string): void {
    state.referrer = payload;
  },
  relativePath(state: FlowState, payload: string): void {
    state.relativePath = payload;
  },
  group(state: FlowState, payload: string): void {
    state.group = payload;
  },
  subgroup(state: FlowState, payload: string): void {
    state.subgroup = payload;
  },
  preferencesSelected(state: FlowState, payload: boolean): void {
    state.preferencesSelected = payload;
  },
  selectedDay(state: FlowState, payload: Date | undefined): void {
    state.selectedDay = payload;
  },
  selectedPeriod(state: FlowState, payload: any): void {
    state.selectedPeriod = payload;
  },
  addressSuggestion(state: FlowState, payload: LocationSuggestion[]): void {
    state.addressSuggestion = payload;
  },
  dealerCalendar(state: FlowState, payload: string): void {
    state.dealerCalendar = payload;
  },
  selectedModelMotorisations(state: FlowState, payload: any[]): void {
    state.selectedModelMotorisations = payload;
  },
  bookingsSearchResults(state: FlowState, payload: any[]): void {
    state.bookingsSearchResults = payload;
  },
  dealersSearchResults(state: FlowState, payload: any[]): void {
    state.dealersSearchResults = payload;
  },
  requestDealersSearchResults(state: FlowState, payload: any[]): void {
    state.requestDealersSearchResults = payload;
  },
  filteredBookingsSearchResults(state: FlowState, payload: any[]): void {
    state.filteredBookingsSearchResults = payload;
  },
  selectedFuelType(state: FlowState, payload: any[]): void {
    state.selectedFuelType = payload;
  },
  selectedTransmission(state: FlowState, payload: any): void {
    state.selectedTransmission = payload;
  },
  selectedDriveType(state: FlowState, payload: any[]): void {
    state.selectedDriveType = payload;
  },
  selectedWheelBase(state: FlowState, payload: any[]): void {
    state.selectedWheelBase = payload;
  },
  selectedWeight(state: FlowState, payload: any[]): void {
    state.selectedWeight = payload;
  },
  selectedMotorisation(state: FlowState, payload: any): void {
    state.selectedMotorisation = payload;
  },
  confirmedMotorisation(state: FlowState, payload: any): void {
    state.confirmedMotorisation = payload;
  },
  confirmedFuelType(state: FlowState, payload: any): void {
    state.confirmedFuelType = payload;
  },
  confirmedTransmission(state: FlowState, payload: any): void {
    state.confirmedTransmission = payload;
  },
  confirmedDriveType(state: FlowState, payload: any): void {
    state.confirmedDriveType = payload;
  },
  confirmedWheelBase(state: FlowState, payload: any): void {
    state.confirmedWheelBase = payload;
  },
  confirmedWeight(state: FlowState, payload: any): void {
    state.confirmedWeight = payload;
  },
  selectedDealerIds(state: FlowState, payload: any): void {
    state.selectedDealerIds = payload;
  },
  selectedTimePeriod(state: FlowState, payload: any): void {
    state.selectedTimePeriod = payload;
  },
  selectedDealer(state: FlowState, payload: any): void {
    state.selectedDealer = payload;
  },
  selectedVehicle(state: FlowState, payload: any): void {
    state.selectedVehicle = payload;
  },
  availableFuelOptions(state: FlowState, payload: any): void {
    state.availableFuelOptions = payload;
  },
  availableTransmissionOptions(state: FlowState, payload: any): void {
    state.availableTransmissionOptions = payload;
  },
  availableMotorisationOptions(state: FlowState, payload: any): void {
    state.availableMotorisationOptions = payload;
  },
  availableDealersOptions(state: FlowState, payload: any): void {
    state.availableDealersOptions = payload;
  },
  availableTimePeriodOptions(state: FlowState, payload: any): void {
    state.availableTimePeriodOptions = payload;
  },
  availableDriveTypeOptions(state: FlowState, payload: any): void {
    state.availableDriveTypeOptions = payload;
  },
  availableWheelBaseOptions(state: FlowState, payload: any): void {
    state.availableWheelBaseOptions = payload;
  },
  availableWeightOptions(state: FlowState, payload: any): void {
    state.availableWeightOptions = payload;
  },
  filtersApplied(state: FlowState, payload: any): void {
    state.filtersApplied = payload;
  },
  isFilterSelected(state: FlowState, payload: any): void {
    state.isFilterSelected = payload;
  },
  isVehicleFilterSelected(state: FlowState, payload: any): void {
    state.isVehicleFilterSelected = payload;
  },
  isVehicleFilterConfirmed(state: FlowState, payload: any): void {
    state.isVehicleFilterConfirmed = payload;
  },
  allVehicleFilters(state: FlowState, payload: any): void {
    state.allVehicleFilters = payload;
  },
  testDriveMode(state: FlowState, payload: TestDriveMode): void {
    state.testDriveMode = payload;
  },
  appointment(state: FlowState, payload: any): void {
    state.appointment = payload;
  },
  prospect(state: FlowState, payload: Prospect): void {
    state.prospect = payload;
  },
  informationSent(state: FlowState, payload: any): void {
    state.informationSent = payload;
  },
  showDetailsModal(state: FlowState, payload: boolean): void {
    state.showDetailsModal = payload;
  },
  showFiltersMenu(state: FlowState, payload: boolean): void {
    state.showFiltersMenu = payload;
  },
  showFiltersModal(state: FlowState, payload: boolean): void {
    state.showFiltersModal = payload;
  },
  firstAvailableDate(state: FlowState, payload: Date): void {
    state.firstAvailableDate = payload;
  },
  searchedDate(state: FlowState, payload: Date | null): void {
    state.searchedDate = payload;
  },
  vehiclePreferences(state: FlowState, payload: any): void {
    state.vehiclePreferences = payload;
  },
  activeCalendarSlide(state: FlowState, payload: number): void {
    state.activeCalendarSlide = payload;
  },
  requestSelectionBoxesStatus(state: FlowState, payload: any): void {
    state.requestSelectionBoxesStatus = payload;
  },
  requestSelectionBoxesStep(state: FlowState, payload: any): void {
    state.requestSelectionBoxesStep = payload;
  },
  errorMessage(state: FlowState, payload: any): void {
    state.errorMessage = payload;
  },
  skippedResultsPage(state: FlowState, payload: boolean): void {
    state.skippedResultsPage = payload;
  },
  isTestDriveFromHome(state: FlowState, payload: boolean): void {
    state.isTestDriveFromHome = payload;
  },
  testDriveFromHomeWhitelistedDealers(
    state: FlowState,
    payload: string[]
  ): void {
    state.testDriveFromHomeWhitelistedDealers = payload;
  },
  didUserConsentWithOneDoc(state: FlowState, payload: boolean): void {
    state.didUserConsentWithOneDoc = payload;
  },
};
